<div class="caption-bar">
  <div class="caption">{{ "constructionSites.title" | translate }}</div>
</div>
<lib-construction-sites></lib-construction-sites>
